module.exports = ".actionth {\n  min-width: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-ap-committee/bc-ap-committee.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-ap-committee/bc-ap-committee.component.scss
// module chunks = main